export interface StepperStage {
  id: string;
  label: string;
  completed: boolean;
}

const DEFAULT_STAGES: StepperStage[] = [
  { id: "profile", label: "Profile", completed: false },
  { id: "evidence", label: "Evidence", completed: false },
  { id: "recommenders", label: "Recommenders", completed: false },
  { id: "draft", label: "Draft", completed: false },
  { id: "review", label: "Attorney Review", completed: false },
];

interface PetitionStepperProps {
  stages?: StepperStage[];
  onStepClick?: (stageId: string) => void;
}

export function PetitionStepper({ stages = DEFAULT_STAGES, onStepClick }: PetitionStepperProps) {
  const completed = stages.filter((s) => s.completed).length;

  return (
    <div className="border-b border-slate-200 bg-white px-4 py-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] font-medium text-slate-500">Petition progress</span>
        <span className="text-[11px] font-semibold text-slate-900">{completed}/{stages.length} stages</span>
      </div>

      {/* Segment track — hover title shows stage name */}
      <div className="flex items-center gap-1">
        {stages.map((stage, idx) => (
          <button
            key={stage.id}
            type="button"
            onClick={() => onStepClick?.(stage.id)}
            title={stage.label}
            aria-label={`Go to ${stage.label}`}
            className={`h-1.5 flex-1 rounded-full transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-periwinkle-blue hover:opacity-80 ${
              stage.completed
                ? "bg-periwinkle-blue"
                : idx === completed
                ? "bg-slate-300"
                : "bg-slate-100"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
